// extracted by mini-css-extract-plugin
export default {"nazwa_input":"Koszt_nazwa_input__6tawS"};